"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.magicLog = exports.errorLog = exports.warnLog = exports.infoLog = void 0;
const warnLogsId = [];
const infoLogsId = [];
const magicLogsId = [];
const errorLogsId = [];
const infoLog = (string, id = '') => {
    const enviroment = process.env.NODE_ENV;
    if (window && enviroment !== 'production' && enviroment !== 'test') {
        const logIsAlreadyPresent = infoLogsId.indexOf(id) > -1 && id;
        if (!logIsAlreadyPresent) {
            warnLogsId.push(id);
            const infoLogCss = 'color:#00A9E0; font-size: 14px; font-weight: bold; padding:5px; padding-left: 0px;';
            console.log(`%c ${string}`, infoLogCss);
        }
    }
};
exports.infoLog = infoLog;
const warnLog = (string, id = '') => {
    const enviroment = process.env.NODE_ENV;
    if (window && enviroment !== 'production' && enviroment !== 'test') {
        const logIsAlreadyPresent = warnLogsId.indexOf(id) > -1 && id;
        if (!logIsAlreadyPresent) {
            warnLogsId.push(id);
            const warnLogCss = 'color:#ec6738; font-size: 14px; font-weight: bold; padding:5px; padding-left: 0px;';
            console.log(`%c ${string}`, warnLogCss);
        }
    }
};
exports.warnLog = warnLog;
const errorLog = (string, id = '') => {
    const enviroment = process.env.NODE_ENV;
    if (window && enviroment !== 'production' && enviroment !== 'test') {
        errorLogsId.push(`${id}${string}`);
        const errorLogCss = 'color:red; font-size: 18px; font-weight: bold; padding:5px; padding-left: 0px;';
        console.log(`%c ${string}`, errorLogCss);
    }
};
exports.errorLog = errorLog;
const magicLog = (string, id = '') => {
    const enviroment = process.env.NODE_ENV;
    const logIsAlreadyPresent = magicLogsId.indexOf(id) > -1 && id;
    if (window && enviroment !== 'production' && enviroment !== 'test') {
        if (!logIsAlreadyPresent) {
            const magicLogCss = 'color:#5bc500; font-size: 14px; font-weight: bold; padding:5px; padding-left: 0px;';
            console.log(`%c ${string}`, magicLogCss);
        }
    }
};
exports.magicLog = magicLog;
//# sourceMappingURL=index.js.map